import { useEffect, useState } from 'react';
import moment from 'moment';

import { useStores } from './use-stores';

export const useValueDashboard = () => {
  const { stationRiskGraphStore, energySavingsStore, energySavingsGraphStore, stationStore } = useStores();

  const [baselineStart, setBaselineStart] = useState(null);
  const [baselineEnd, setBaselineEnd] = useState(null);
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    energySavingsGraphStore.yearlyViewOpen && stationRiskGraphStore.setYearlyViewOpen(false);
  }, [energySavingsGraphStore.yearlyViewOpen]);

  useEffect(() => {
    stationRiskGraphStore.yearlyViewOpen && energySavingsGraphStore.setYearlyViewOpen(false);
  }, [stationRiskGraphStore.yearlyViewOpen]);

  useEffect(() => {
    if (!stationStore.isLoading) {
      energySavingsStore.get();
      energySavingsGraphStore.get();
      energySavingsGraphStore.getBaselinePeriods();
    }
  }, [stationStore.isLoading]);

  useEffect(() => {
    if (energySavingsGraphStore.baselineData) {
      setBaselineStart(`${moment(energySavingsGraphStore.baselineData?.startDate).utc().format('MMM D, YYYY')}`);
      setBaselineEnd(`${moment(energySavingsGraphStore.baselineData?.endDate).utc().format('MMM D, YYYY')}`);
    }
  }, [energySavingsGraphStore.baselineData]);

  useEffect(() => {
    if (!isFirstRender) {
      energySavingsGraphStore.getGraphByYear(energySavingsStore.requestedYear);
    } else {
      setIsFirstRender(false);
    }
  }, [stationStore.currentStation]);

  return { baselineStart, baselineEnd };
};
